import { App } from 'vue'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import PageModalTable from '@/components/PageModalTable.vue'
import BaseEchart from '@/components/BaseEchart.vue'
import BasicForm from '@/components/BasicForm.vue'

export function registerCustom(app: App): void {
  app.component('PageSearch', PageSearch)
  app.component('PageContent', PageContent)
  app.component('PageModal', PageModal)
  app.component('PageModalTable', PageModalTable)
  app.component('BaseEchart', BaseEchart)
  app.component('BasicForm', BasicForm)
}
